import React from 'react';
import {Link} from 'react-router-dom';

const TopicItem = ({topic, user}) => (
  <div className="topic-item">
    <Link to={user || (!user && topic.id === 11) ? `/topic/${topic.id}` : '/'}>{topic.title}</Link>
  </div>
);

export default TopicItem;


// WEBPACK FOOTER //
// ./src/modules/topic/components/TopicItem.js